(function () {
    "use strict";

    angular
        .module("app")
        .directive("materialGridSearchHelp", ["SearchFactory", materialGridSearchHelp]);

    function materialGridSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {

                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.materialGridName = "";
                        scope.materialGridKey = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.materialGridName === scope.displayValue)) {
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.materialGridSearch(function (materialGrid) {
                        scope.materialGridKey = materialGrid ? materialGrid.MaterialGridName : "";
                        scope.materialGridName = materialGrid ? materialGrid.MaterialGridDesc : "";
                        scope.displayValue = scope.materialGridName;

                        if (scope.prevDisplayValue !== scope.displayValue) {

                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.displayValue = scope.materialGridName;
                scope.prevDisplayValue = scope.displayValue;


                scope.$watch("materialGridName", function (newValue) {
                    scope.displayValue = newValue;

                });
            },
            scope: { materialGridKey: "=", materialGridName: "=", readOnly: "=", required: "=", controlName: "@", needToValidate: "=", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();
